import type { ReactNode } from "react";

export interface BadgeContainerProps {
  children: ReactNode;
}

export const BadgeContainer = ({ children }: BadgeContainerProps) => (
  <div className="flex items-center justify-between">{children}</div>
);
